/* ISG personaliser, part 5 of 5 (built by tools/split.js from isg-personaliser.js md5 aceaaca6061588d0d715ab3ec4d20473; load after part 4). */
(function (root) {
  'use strict';
  var NS = root.__isgPz;
  if (!NS || NS.__parts !== 4) { if (root.console) root.console.error('ISG personaliser: part 5 loaded before part 4'); return; }
  var round1 = NS.round1, angleText = NS.angleText, textLines = NS.textLines, effectivePpi = NS.effectivePpi, chargeCounts = NS.chargeCounts, scaleForSize = NS.scaleForSize, placementText = NS.placementText, makeRef = NS.makeRef, leftoverLines = NS.leftoverLines, uploadGroups = NS.uploadGroups, previewNote = NS.previewNote, doc = NS.doc, xhrPost = NS.xhrPost, requestJson = NS.requestJson, isStoredUpload = NS.isStoredUpload, Personaliser = NS.Personaliser;


  // Properties for one garment line. art/previews: values (File/Blob for the first line, stored URLs after).
  Personaliser.prototype.lineProps = function (dz, line, ref, art, previews) {
    var self = this, props = [];
    var counts = {};
    dz.prints.forEach(function (p) { var t = self.sizesByKey[p.sizeKey]; counts[t.label] = (counts[t.label] || 0) + 1; });
    props.push(['Design ref', ref]);
    if (this.designs.length > 1) props.push(['Design', 'Design ' + dz.id]);
    props.push(['Prints', dz.prints.length + ' print' + (dz.prints.length === 1 ? '' : 's') + ': ' + Object.keys(counts).map(function (k) { return counts[k] + ' × ' + k; }).join(', ')]);
    dz.prints.forEach(function (p, i) {
      var n = i + 1, tier = self.sizesByKey[p.sizeKey], side = self.sidesByKey[p.side];
      // The print as it will be printed on this line's size: scaled and kept inside the smaller area (review point 2).
      var sp = scaleForSize(p, side, self.sizeMaxWidth(line.size));
      var k = p.w ? sp.w / p.w : 1, aw = sp.w, ah = sp.h;
      if (p.rot) sp.rotNote = angleText(p.rot);
      var isText = p.kind === 'text';
      props.push(['Print ' + n, side.name + ' · ' + tier.label + ' print (up to ' + tier.maxW + ' × ' + tier.maxH + ' cm) · ' + (isText ? 'text · ' : '') + 'printed size on ' + line.size + ': ' + round1(aw).toFixed(1) + ' × ' + round1(ah).toFixed(1) + ' cm' +
        (p.rot ? ', ' + angleText(p.rot) + ' (takes up ' + round1(sp.foot.w).toFixed(1) + ' × ' + round1(sp.foot.h).toFixed(1) + ' cm)' : '') +
        (sp.scaled ? ' (scaled down from ' + round1(p.w).toFixed(1) + ' × ' + round1(p.h).toFixed(1) + ' cm for this size)' : '') +
        (sp.moved && (sp.moved.x || sp.moved.y) ? ' (moved to stay inside the print area on this size)' : '')]);
      if (isText) {
        var tl = textLines(p.text.value);
        props.push(['Print ' + n + ' text', tl.map(function (l) { return '“' + l + '”'; }).join(' / ') + (tl.length > 1 ? ' (' + tl.length + ' lines)' : '')]);
        props.push(['Print ' + n + ' font', p.text.family + (p.text.weight && p.text.weight !== 400 ? ' ' + p.text.weight : '') + ', ' + p.text.colourName + ' (' + p.text.colour + ')' +
          (tl.length > 1 ? ', lines ' + (p.text.align === 'center' ? 'centred' : p.text.align + '-aligned') : '') +
          (p.textFile && p.textFile.fallback ? ' – the font did not load on the customer’s device, so the attached file uses a stand-in font: set it in ' + p.text.family : '')]);
      }
      props.push(['Print ' + n + ' artwork', art[p.uid]]);
      props.push(['Print ' + n + ' placement', placementText(sp, side, line.size)]);
      props.push(['Print ' + n + ' file check', isText && p.textFile
        ? 'Text made into a transparent PNG, ' + p.textFile.w + ' × ' + p.textFile.h + ' px, about ' + Math.round(p.textFile.ppi / k) + ' pixels per inch at printed size'
        : p.art.w + ' × ' + p.art.h + ' px' + (p.art.trimmed ? ', artwork area ' + p.art.bbox.w + ' × ' + p.art.bbox.h + ' px' : '') + ', about ' + Math.round(Math.min(effectivePpi(p.art.bbox.w, aw), effectivePpi(p.art.bbox.h, ah))) + ' pixels per inch at printed size']);
    });
    Object.keys(previews).forEach(function (k) { props.push(['Preview ' + k, previews[k]]); });
    // Which colour and photo size the previews represent, and this line's own size (review point 6).
    props.push(['Preview shows', previewNote(line.colour, (this.data.settings.referenceSize || '').trim(), line.size)]);
    var notes = this.q('[data-pz-notes]').value.trim();
    if (notes) props.push(['Notes', notes]);
    var preset = dz.prints.some(function (p) { var sd = self.sidesByKey[p.side]; return !sd.areaStatus || sd.areaStatus === 'proposed'; });
    props.push(['Mock-up', 'To be approved by the customer before printing' + (preset ? ' (print area is a standard preset, not measured – check the fit on the mock-up)' : '')]);
    props.push(['Placement status', this.placementStatusText() + (this.calib === 'estimated' ? '; preview scale estimated' : this.calib === 'calibrated' ? '; preview scale calibrated (' + this.calibValues.garmentWidthCm + ' cm garment width, print area ' + this.calibValues.collarToPrintCm + ' cm below the top)' : '')]);
    props.push(['_isg_prints', JSON.stringify(chargeCounts(dz.prints, this.sizesByKey))]);
    return props;
  };

  /*
   * Remove every basket line from this attempt (and any earlier failed attempts of this product in this tab), then
   * re-read the basket to confirm they are gone (review point 5). Resolves { ok, left: [line keys still there] }.
   */
  Personaliser.prototype.rollback = function (refBases) {
    var d = this.data;
    var root_ = d.cartUrl.replace(/\/cart$/, '') + '/';
    var bases = refBases.slice();
    return requestJson(root_ + 'cart.js').then(function (cart) {
      var keys = leftoverLines(cart, bases);
      if (!keys.length) return null;
      var updates = {};
      keys.forEach(function (k) { updates[k] = 0; });
      return requestJson(root_ + 'cart/update.js', { updates: updates });
    }).then(function () {
      return requestJson(root_ + 'cart.js');
    }).then(function (cart) {
      var left = leftoverLines(cart, bases);
      return { ok: !left.length, left: left };
    }).catch(function () {
      return { ok: false, left: null, unknown: true };
    });
  };

  // Lines of an earlier failed attempt that may still be in the basket are removed before a new attempt, so a retry
  // never duplicates items. Resolves true when the basket is clear of them.
  Personaliser.prototype.clearPending = function () {
    var self = this;
    if (!this.pendingRefs.length) return Promise.resolve(true);
    return this.rollback(this.pendingRefs).then(function (r) {
      if (r.ok) { self.pendingRefs = []; self.savePendingRefs(); }
      return r.ok;
    });
  };

  // The design details as text, for the mock-up request (unverified placements) and for the team.
  Personaliser.prototype.designSummary = function () {
    var self = this, d = this.data, out = [];
    out.push('Product: ' + d.productTitle + ' (' + d.productUrl + ')');
    out.push('Placement status: ' + this.placementStatusText());
    this.rows.forEach(function (r) {
      var sizes = [];
      (self.sizeCache[r.colour] || []).forEach(function (sv) { if (r.qty[sv.name]) sizes.push(sv.name + ' × ' + r.qty[sv.name]); });
      if (sizes.length) out.push('Colour ' + r.colour + ' (Design ' + r.designId + '): ' + sizes.join(', '));
    });
    this.usedDesigns().forEach(function (dz) {
      dz.prints.forEach(function (p, i) {
        var side = self.sidesByKey[p.side], tier = self.sizesByKey[p.sizeKey];
        var sp = scaleForSize(p, side, null);
        out.push('Design ' + dz.id + ' print ' + (i + 1) + ': ' + (side ? side.name : '') + ', ' + (tier ? tier.label : '') + ', ' +
          (p.kind === 'text' ? 'text “' + textLines(p.text.value).join(' / ') + '” in ' + p.text.family + ' ' + p.text.colourName : 'artwork ' + (p.art && p.art.file ? p.art.file.name : '')) +
          ', ' + round1(p.w).toFixed(1) + ' × ' + round1(p.h).toFixed(1) + ' cm' + (p.rot ? ', ' + angleText(p.rot) : '') + ', ' + placementText(sp, side, (d.settings.referenceSize || '').trim() || null));
      });
    });
    var notes = this.q('[data-pz-notes]').value.trim();
    if (notes) out.push('Notes: ' + notes);
    return out.join('\n');
  };

  // Unverified placement: send the design to the shop as a mock-up request through the contact form (no order).
  Personaliser.prototype.requestMockup = function () {
    var form = this.q('[data-pz-mockup]');
    var email = this.q('[data-pz-email]');
    if (!form || !email) { this.showError('Mock-up requests are not set up on this page yet. Please contact us with your design.'); return; }
    var ref = makeRef();
    var body = 'Mock-up request ' + ref + '\n' + this.designSummary() + '\nArtwork: please reply to this email with your artwork file(s) attached, quoting ' + ref + '.';
    var set = function (name, value) {
      var inp = form.querySelector('[name="' + name + '"]');
      if (!inp) { inp = doc.createElement('input'); inp.type = 'hidden'; inp.name = name; form.appendChild(inp); }
      inp.value = value;
    };
    set('contact[email]', String(email.value || '').trim());
    set('contact[body]', body);
    set('contact[Mock-up request]', ref);
    set('contact[Product]', this.data.productTitle);
    this.busy = true;
    this.update();
    form.submit();
  };

  Personaliser.prototype.submit = function () {
    var self = this, d = this.data;
    if (this.busy || this.blockers().length) { this.update(); return; }
    if (this.orderMode() === 'mockup') { this.requestMockup(); return; }
    var lines = this.lines();
    var designs = this.usedDesigns();
    var refBase = makeRef();
    this.busy = true;
    this.showError('');
    this.update();
    this.setProgress(0, 'Checking your basket…');
    var cartLink = ' <a href="' + d.cartUrl + '">Check your basket</a> before trying again.';

    // Previews are made per design AND colour (review point 6); artwork is uploaded once per design.
    var groups = uploadGroups(lines).map(function (g) {
      return { designId: g.designId, colour: g.colour, lines: g.lines, dz: designs.filter(function (x) { return x.id === g.designId; })[0] };
    });
    var stored = {};   // design id -> { art: {uid: url}, textFiles }
    var previews = {}; // design id + '|' + colour -> { side: url }
    var step = 0, steps = groups.length + 1;

    // Lines of an earlier failed attempt are removed first, so a retry can't duplicate them.
    var chain = this.clearPending().then(function (clear) {
      if (!clear) throw { userMessage: 'Some items from an earlier attempt may still be in your basket and we couldn’t remove them.' + cartLink, keepPending: true };
      self.pendingRefs.push(refBase); self.savePendingRefs();
    });

    groups.forEach(function (g) {
      chain = chain.then(function () {
        var dz = g.dz, first = g.lines[0];
        var ref = refBase + '-' + dz.id;
        var sidesUsed = d.sides.filter(function (s) { return dz.prints.some(function (p) { return p.side === s.key; }); });
        var firstOfDesign = !stored[dz.id];
        var textFiles = {};
        self.setProgress(step / steps, 'Preparing your previews (' + g.colour + ')…');
        return Promise.all(dz.prints.map(function (p, i) {
          if (p.kind !== 'text' || !firstOfDesign) return null;
          return self.makeTextFile(p, 'text-print-' + (i + 1) + '-' + ref + '.png').then(function (f) { textFiles[p.uid] = f; });
        })).then(function () {
          return Promise.all(sidesUsed.map(function (s) { return self.renderPreview(dz, s, g.colour); }));
        }).then(function (blobs) {
          var art = {}, pv = {};
          dz.prints.forEach(function (p) { art[p.uid] = firstOfDesign ? (p.kind === 'text' ? textFiles[p.uid] : p.art.file) : stored[dz.id].art[p.uid]; });
          sidesUsed.forEach(function (s, i) { pv[s.name.toLowerCase()] = blobs[i] || 'Not available'; });
          var fd = new FormData();
          fd.append('id', String(first.variant.id));
          fd.append('quantity', String(first.qty));
          self.lineProps(dz, first, ref, art, pv).forEach(function (kv) {
            var v = kv[1];
            if (v instanceof Blob) fd.append('properties[' + kv[0] + ']', v, v.name || ('preview-' + kv[0].replace(/\W+/g, '-').toLowerCase() + '-' + g.colour.replace(/\W+/g, '-').toLowerCase() + '-' + ref + '.jpg'));
            else fd.append('properties[' + kv[0] + ']', v);
          });
          var label = (groups.length > 1 ? 'Uploading ' + (designs.length > 1 ? 'Design ' + dz.id + ' ' : '') + g.colour + '… ' : 'Uploading your artwork… ');
          return xhrPost(d.cartAddUrl, fd, function (f) {
            self.setProgress((step + f * 0.95) / steps, f < 1 ? label + Math.round(f * 100) + '%' : 'Saving…');
          }).then(function (line) {
            var props = line.properties || {};
            var missing = dz.prints.filter(function (p, i) { return !isStoredUpload(props['Print ' + (i + 1) + ' artwork']); });
            if (missing.length) throw { userMessage: 'Your artwork did not finish uploading. Please try again.' };
            if (firstOfDesign) {
              stored[dz.id] = { art: {} };
              dz.prints.forEach(function (p, i) { stored[dz.id].art[p.uid] = props['Print ' + (i + 1) + ' artwork']; });
            }
            var key = dz.id + '|' + g.colour;
            previews[key] = {};
            sidesUsed.forEach(function (s) {
              var v = props['Preview ' + s.name.toLowerCase()];
              previews[key][s.name.toLowerCase()] = isStoredUpload(v) ? v : 'Not available';
            });
            step++;
          });
        });
      });
    });

    chain.then(function () {
      self.setProgress(groups.length / steps, 'Adding sizes, colours and print charges…');
      var items = [];
      groups.forEach(function (g) {
        var dz = g.dz, ref = refBase + '-' + dz.id;
        g.lines.slice(1).forEach(function (l) {
          var props = {};
          self.lineProps(dz, l, ref, stored[dz.id].art, previews[dz.id + '|' + g.colour]).forEach(function (kv) { props[kv[0]] = kv[1]; });
          items.push({ id: l.variant.id, quantity: l.qty, properties: props });
        });
      });
      designs.forEach(function (dz) {
        var ref = refBase + '-' + dz.id;
        var totalQty = 0;
        lines.forEach(function (l) { if (l.designId === dz.id) totalQty += l.qty; });
        var counts = chargeCounts(dz.prints, self.sizesByKey);
        Object.keys(counts).forEach(function (vid) {
          items.push({
            id: parseInt(vid, 10), quantity: counts[vid] * totalQty,
            properties: { For: d.productTitle + (designs.length > 1 ? ' – Design ' + dz.id : '') + ' (' + totalQty + (self.bagMode ? ' bags)' : ' garments)'), 'Design ref': ref, _isg_charge: '1' }
          });
        });
      });
      return items.length ? requestJson(d.cartAddUrl, { items: items }) : null;
    }).then(function () {
      self.pendingRefs = self.pendingRefs.filter(function (r) { return r !== refBase; }); self.savePendingRefs();
      self.setProgress(1, 'Added. Taking you to your basket…');
      self.busy = false;
      root.location.href = d.cartUrl;
    }).catch(function (err) {
      var reason = (err && err.userMessage) ||
        (err && err.json && (err.json.description || err.json.message) ? (err.json.description || err.json.message) : null) ||
        (err && err.status === 0 ? 'The upload was interrupted. Please check your connection and try again.' : 'Something went wrong adding this to your basket.');
      if (err && err.keepPending) {
        self.busy = false; self.setProgress(null); self.showError(reason, true); self.update();
        return;
      }
      // Remove whatever was added by this attempt, then confirm by re-reading the basket (review point 5).
      return self.rollback([refBase]).then(function (r) {
        self.busy = false;
        self.setProgress(null);
        if (r.ok) {
          self.pendingRefs = self.pendingRefs.filter(function (x) { return x !== refBase; }); self.savePendingRefs();
          self.showError(reason + ' Nothing was added to your basket.');
        } else {
          // the clean-up could not be confirmed: say so, and keep the ref so the next attempt removes the leftovers first
          self.showError(reason + ' Some items from this attempt may still be in your basket.' + cartLink, true);
        }
        self.update();
      });
    });
  };

  function boot() {
    Array.prototype.forEach.call(doc.querySelectorAll('[data-isg-pz]'), function (node) {
      if (node.__isgPz) return;
      try { node.__isgPz = new Personaliser(node); } catch (e) {
        var err = node.querySelector('[data-pz-error]');
        if (err) { err.hidden = false; err.textContent = 'The personaliser could not load. Please refresh the page or contact us.'; }
        if (root.console) root.console.error(e);
      }
    });
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* hand-over to the next part */
  NS.__parts = 5;
})(typeof window !== 'undefined' ? window : globalThis);
